export const absentTypeOptions = [
  { value: 'SINGLE_MISSED_SHIFT', label: 'single shift' },
  { value: 'CONSECUTIVE_MISSED_SHIFT', label: 'consecutive shifts' },
];

export const shiftDurationOptions = [
  { value: 'any_shift', label: 'any shift duration', shiftFilterMinHours: null, shiftFilterMaxHours: null },
  { value: 'up_to_4_hours', label: 'shifts up to 4 hours', shiftFilterMinHours: null, shiftFilterMaxHours: 4 },
  {
    value: '4_to_8_hours',
    label: 'shifts over 4 hours and up to 8 hours',
    shiftFilterMinHours: 4,
    shiftFilterMaxHours: 8,
  },
  { value: 'over_8_hours', label: 'shifts over 8 hours', shiftFilterMinHours: 8, shiftFilterMaxHours: null },
];

export const POINTS_DAYS_OPTIONS = {
  ALL_DAYS: 'ALL_DAYS',
  WEEKDAYS: 'WEEKDAYS',
  WEEKENDS: 'WEEKENDS',
};

export const daysOptions = [
  { value: POINTS_DAYS_OPTIONS.ALL_DAYS, label: 'all days' },
  { value: POINTS_DAYS_OPTIONS.WEEKDAYS, label: 'weekdays' },
  { value: POINTS_DAYS_OPTIONS.WEEKENDS, label: 'weekends' },
];
